import React from "react";
import { useDrag } from "react-dnd";
import { ColumnType, Task } from "../../types/types";
import Card from "../Card/Card";

interface DraggableCardProps {
  task: Task;
  onDrop: (taskId: number, newColumn: ColumnType) => void;
  onCardClick?: (task: Task) => void;
}

const DraggableCard: React.FC<DraggableCardProps> = ({ task, onDrop, onCardClick }) => {
  const [{ isDragging }, drag] = useDrag({
    item: { type: "CARD", id: task.id },
    end: (item: any, monitor) => {
      const dropResult: any = monitor.getDropResult();
      if (item && dropResult) {
        onDrop(item.id, dropResult.column);
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return (
    <div
      ref={drag}
      style={{ 
        opacity: isDragging ? 0.5 : 1, 
        cursor: 'move',
        backgroundColor: isDragging ? '#e0e0e0' : 'transparent'
      }}
    >
      <Card task={task} onClick={onCardClick} />
    </div>
  );
};

export default DraggableCard;
